// -----------------------------------------------------------------------------
// Registrierung
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';

window.Mustache = Mustache; // eslint-disable-line no-undef

const init = () => {
  if ($('.js-body').hasClass('js-body-register') === false) {
    return;
  }

  initEventListeners();
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  const trans = generalUtility.getJsonFromHtml('.js-body-register #trans');
  const $fieldPw = $('#frmPW');
  const $fieldPw2 = $('#frmPW2');

  $fieldPw.keyup(function () {
    const basepath = $('.js-body').attr('data-basepath');

    $.ajax({
      method: 'POST',
      url: `${basepath}/pw_check.php`,
      data: {
        PW: $fieldPw.val()
      }
    })
      .done(function (strength) {
        let strengthMSG = '';

        // Info an User
        if (strength < 3) {
          strengthMSG = trans.pw_zu_schwach;
        } else if (strength < 4) {
          strengthMSG = trans.pw_sicher;
        } else {
          strengthMSG = trans.pw_sehr_sicher;
        }

        // Eingabefeld-Style
        if (strength < 3) {
          $('#frmPW').css('box-shadow', '0 0 0 0.2rem rgba(255, 0, 0, .5)');
        } else {
          $('#frmPW').css('box-shadow', '0 0 0 0.2rem rgba(0, 255, 0, .5)');
        }

        // Button-Status
        if (strength < 3 || $fieldPw.val() !== $fieldPw2.val()) {
          $('#frmSubmit').prop('disabled', true);
        } else {
          $('#frmSubmit').prop('disabled', false);
        }

        $('.frmPW_message').html(strengthMSG).show();
      })
      .fail(function () {
      });
  });

  $fieldPw2.keyup(function () {
    if ($(this).val() !== $fieldPw.val()) {
      $('.frmPW_message2').html(trans.pw_stimmen_nicht_ueberein).show();
      $('#frmSubmit').prop('disabled', true);
    } else {
      $('.frmPW_message2').hide();
      $('#frmSubmit').prop('disabled', false);
    }
  });
};

export {
  init
};
